// Ian - 2026-05-28 - Stove Finder quiz logic.
// Self-contained, no dependencies. Reads product data baked into the section,
// filters/ranks by the buyer's three answers, shows the top picks inline, links
// "View all" to the closest collection, and opens Shopify Inbox or a message popup.
(function () {
  'use strict';

  function parseKw(range, nominal) {
    var text = (range || '').toString();
    var nums = text.match(/\d+(?:\.\d+)?/g);
    if (nums && nums.length) {
      var a = parseFloat(nums[0]);
      var b = nums.length > 1 ? parseFloat(nums[1]) : a;
      return { min: Math.min(a, b), max: Math.max(a, b) };
    }
    var n = (nominal || '').toString().match(/\d+(?:\.\d+)?/);
    if (n) { var v = parseFloat(n[0]); return { min: v, max: v }; }
    return null;
  }

  function fuelList(p) {
    return (p.fuel || []).map(function (f) { return ('' + f).toLowerCase(); });
  }

  function passesFlue(p, flue) {
    if (flue === 'flueless') {
      var f = fuelList(p);
      return f.length > 0 && f.every(function (x) { return x === 'electric' || x === 'bioethanol'; });
    }
    return true; // all / twinwall / unsure
  }

  function score(p, ans) {
    var s = 0;
    var f = fuelList(p);
    if (ans.priority === 'warmth' && (f.indexOf('wood') > -1 || f.indexOf('multifuel') > -1)) s += 3;
    if (ans.priority === 'looks' && f.indexOf('electric') > -1) s += 3;
    if (ans.priority === 'easy' && f.indexOf('electric') > -1) s += 3;
    if (ans.priority === 'emissions' && (p.defra || p.cleanburn)) s += 3;
    if (p._kw && ans.room && p._kw.min <= ans.room.kwMax && ans.room.kwMin <= p._kw.max) s += 2;
    if (p.defra) s += 0.5;
    s += Math.min(parseFloat(p.rating) || 0, 5) * 0.1;
    // Prioritised products jump to the top, but only when already a relevant match
    // (score >= 2 means they earned a fuel/priority or kW-band point first).
    if (p.boost && s >= 2) s += 3;
    return s;
  }

  function fuelWord(p) {
    var f = fuelList(p);
    if (f.indexOf('multifuel') > -1) return 'multifuel stove';
    if (f.indexOf('wood') > -1) return 'wood-burning stove';
    if (f.indexOf('electric') > -1) return 'electric fire';
    return 'stove';
  }

  function rank(list, ranking) {
    list.sort(function (a, b) {
      if (b._score !== a._score) return b._score - a._score;
      if (ranking === 'price') {
        if (a.priceMin !== b.priceMin) return a.priceMin - b.priceMin;
        return (b.rating || 0) - (a.rating || 0);
      }
      if ((b.rating || 0) !== (a.rating || 0)) return (b.rating || 0) - (a.rating || 0);
      return a.priceMin - b.priceMin;
    });
    return list;
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function buildCard(p) {
    var a = el('a', 'ian-sf__pick');
    a.href = p.url;
    var media = el('span', 'ian-sf__pick-media');
    if (p.image) {
      var img = el('img');
      img.src = p.image; img.alt = p.title; img.loading = 'lazy'; img.decoding = 'async'; img.width = 88; img.height = 88;
      media.appendChild(img);
    }
    a.appendChild(media);
    var body = el('span', 'ian-sf__pick-body');
    body.appendChild(el('span', 'ian-sf__pick-title', p.title));
    var price = p.priceRange ? 'From ' + p.priceDisplay : p.priceDisplay;
    body.appendChild(el('span', 'ian-sf__pick-price', price));
    a.appendChild(body);
    return a;
  }

  function withinHours(start, end) {
    var s = parseInt(start, 10), e = parseInt(end, 10);
    if (isNaN(s) || isNaN(e)) return true;
    var h = new Date().getHours();
    return h >= s && h < e;
  }

  function openInbox() {
    // Ian - 2026-06-08 - Shopify Inbox renders its launcher inside the shadow root of
    // <inbox-online-store-chat> (host id "ShopifyChat"). The old #shopify-chat wrapper div
    // is not the clickable launcher, so clicking it did nothing yet still reported success,
    // which blocked the leave-a-message fallback. Reach the real toggle in the shadow root.
    var host = document.querySelector('inbox-online-store-chat') || document.getElementById('ShopifyChat');
    if (host && host.shadowRoot) {
      if (host.getAttribute('is-open') === 'true') return true; // already open, leave it
      var toggle = host.shadowRoot.querySelector('.chat-toggle, button, [role="button"]');
      if (toggle) { toggle.click(); return true; }
    }
    return false; // Inbox not present/loaded -> caller falls back to the message popup
  }

  function initFinder(root) {
    var dataEl = root.querySelector('[data-sf-products]');
    var products = [];
    try { products = JSON.parse(dataEl.textContent.trim() || '[]'); } catch (err) { products = []; }
    products.forEach(function (p) { p._kw = parseKw(p.kwRange, p.kwNominal); });

    var ranking = root.getAttribute('data-ranking') || 'rating';
    var chatEnabled = root.getAttribute('data-chat-enabled') === 'true';
    var hoursStart = root.getAttribute('data-hours-start');
    var hoursEnd = root.getAttribute('data-hours-end');
    var contactUrl = root.getAttribute('data-contact-url');

    var panels = {
      1: root.querySelector('[data-sf-panel="1"]'),
      2: root.querySelector('[data-sf-panel="2"]'),
      3: root.querySelector('[data-sf-panel="3"]'),
      results: root.querySelector('[data-sf-panel="results"]')
    };
    var progressbar = root.querySelector('[data-sf-progressbar]');
    var stepSpans = root.querySelectorAll('[data-sf-steps] [data-step]');
    var restartBtn = root.querySelector('[data-sf-restart]');
    var answers = {};

    // Leave-a-message popup
    var modal = root.querySelector('[data-sf-modal]');
    var lastFocus = null;
    function openModal() {
      if (!modal) { window.location.href = contactUrl || '/pages/contact'; return; }
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var first = modal.querySelector('input, textarea, button');
      if (first) first.focus();
    }
    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    if (modal) {
      modal.querySelectorAll('[data-sf-modal-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
      var cform = modal.querySelector('[data-sf-contact-form]');
      var csuccess = modal.querySelector('[data-sf-modal-success]');
      if (cform) {
        cform.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = cform.querySelector('[type="submit"]');
          var orig = btn ? btn.textContent : '';
          if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
          fetch('/contact', { method: 'POST', body: new FormData(cform), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function () { cform.hidden = true; if (csuccess) csuccess.hidden = false; })
            .catch(function () { if (btn) { btn.disabled = false; btn.textContent = orig; } cform.submit(); });
        });
      }
    }

    // Pick the closest collection for the "View all" link, based on the top result.
    function pickCollection(top) {
      var f = fuelList(top);
      var ds = root.dataset;
      function opt(url, title, fallbackLabel) {
        if (!url) return null;
        return { url: url, label: title ? ('View all ' + title) : fallbackLabel };
      }
      var choice = null;
      if (answers.priority === 'emissions') choice = opt(ds.colDefraUrl, ds.colDefraTitle, 'View all DEFRA approved stoves');
      else if (f.indexOf('electric') > -1) choice = opt(ds.colElectricUrl, ds.colElectricTitle, 'View all electric fires');
      else if (f.indexOf('wood') > -1 || f.indexOf('multifuel') > -1) choice = opt(ds.colWoodUrl, ds.colWoodTitle, 'View all wood burning stoves');
      if (!choice) choice = opt(ds.colDefaultUrl, ds.colDefaultTitle, 'View all stoves');
      return choice;
    }

    function show(step) {
      Object.keys(panels).forEach(function (k) { if (panels[k]) panels[k].hidden = (k != step); });
      var pct = step === 'results' ? 100 : (parseInt(step, 10) / 3) * 100;
      if (progressbar) progressbar.style.width = pct + '%';
      stepSpans.forEach(function (sp) {
        var n = sp.getAttribute('data-step');
        sp.classList.toggle('is-active', step !== 'results' && n <= ('' + step));
      });
      if (restartBtn) restartBtn.hidden = (step === '1' || step === 1);
    }

    function renderResults() {
      var candidates = products.filter(function (p) { return passesFlue(p, answers.flue); });
      candidates.forEach(function (p) { p._score = score(p, answers); });
      rank(candidates, ranking);

      var titleEl = root.querySelector('[data-sf-results-title]');
      var subEl = root.querySelector('[data-sf-results-sub]');
      var grid = root.querySelector('[data-sf-results-grid]');
      var viewAll = root.querySelector('[data-sf-viewall]');
      grid.textContent = '';

      if (!candidates.length) {
        titleEl.textContent = "Let's find this together.";
        subEl.textContent = "Nothing matched those exact answers online, but our team will know what fits. Have a quick chat below.";
        viewAll.hidden = true;
      } else {
        var top = candidates[0];
        var defraWord = (answers.priority === 'emissions' || top.defra) ? 'DEFRA ' : '';
        var kw = answers.room ? answers.room.kwMin + '-' + answers.room.kwMax + 'kW' : '';
        titleEl.textContent = "We'd start with a " + defraWord + fuelWord(top) + (kw ? ' in the ' + kw + ' range.' : '.');
        subEl.textContent = answers.flue === 'unsure'
          ? "Not sure on your flue? We've shown options across the board, our team can confirm what fits."
          : "Based on your answers, here's where we'd start:";

        candidates.slice(0, 3).forEach(function (p) { grid.appendChild(buildCard(p)); });

        var dest = pickCollection(top);
        if (dest && dest.url) {
          viewAll.hidden = false;
          viewAll.textContent = dest.label + ' →';
          viewAll.onclick = function () { window.location.href = dest.url; };
        } else {
          viewAll.hidden = true;
        }
      }

      // Talk-to-a-human box
      var talkSub = root.querySelector('[data-sf-talk-sub]');
      var talkBtn = root.querySelector('[data-sf-talk-btn]');
      var open = chatEnabled && withinHours(hoursStart, hoursEnd);
      if (!open && talkSub && talkBtn) {
        talkSub.textContent = "We're closed right now, leave a message and we'll reply when we're back.";
        talkBtn.textContent = 'Leave a message';
      }
      if (talkBtn) {
        talkBtn.onclick = function () {
          if (open && openInbox()) return;
          openModal();
        };
      }

      show('results');
    }

    root.querySelectorAll('[data-sf-answer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var type = btn.getAttribute('data-sf-answer');
        var panel = btn.closest('.ian-sf__panel');
        if (panel) panel.querySelectorAll('.ian-sf__option').forEach(function (o) { o.classList.remove('is-selected'); });
        btn.classList.add('is-selected');

        if (type === 'room') {
          answers.room = {
            kwMin: parseFloat(btn.getAttribute('data-kw-min')),
            kwMax: parseFloat(btn.getAttribute('data-kw-max'))
          };
          show('2');
        } else if (type === 'flue') {
          answers.flue = btn.getAttribute('data-flue');
          show('3');
        } else if (type === 'priority') {
          answers.priority = btn.getAttribute('data-priority');
          renderResults();
        }
      });
    });

    if (restartBtn) {
      restartBtn.addEventListener('click', function () {
        answers = {};
        root.querySelectorAll('.ian-sf__option.is-selected').forEach(function (o) { o.classList.remove('is-selected'); });
        show('1');
      });
    }

    show('1');
  }

  function init() {
    document.querySelectorAll('[data-ian-stove-finder]').forEach(initFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
